import { ContainerDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { catchError, map, pluck } from 'rxjs/operators'
import Component from 'vue-class-component'
import * as _ from 'lodash'

import { Routes } from '../../../router'
import { CreateContainerForm } from './create-container-form'
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics'
import { of } from 'rxjs'

@Component({
    components: {
        sCreateContainerForm: CreateContainerForm,
    },
    template: require('./create-container-modal.html'),
})
export class CreateContainerModal extends ReactiveVue {
    public $containerDataStore: ContainerDataStore
    public mounted = false

    public $refs: {
        modal: any
    }

    public open() {
        this.$refs.modal.show()
    }

    public onHide() {
        this.mounted = false
    }

    public onShow() {
        this.mounted = true
    }

    public onSubmit(values) {
        const newContainer = {}
        _.set(newContainer, `containerItemSchema.name.translatedString.${this.getAppLocale()}`, values.name)
        _.set(newContainer, 'containerItemSchema.openContainer', true)
        _.set(newContainer, 'identificationItemSchema.identifiers[0].identifier', values.identifier)
        if(values.itemType) {
            _.set(newContainer, 'descriptionItemSchema.itemType', [values.itemType])
        }
        _.set(newContainer, 'locationItemSchema.realTimeLocation.realTimeLocation', values.location?.id)
        const createContainer$ = this.$containerDataStore
            .create({}, newContainer)
            .pipe(
                pluck('id'),
                map(id => {
                    return {
                        success: true,
                        data: id,
                    }
                }),
                catchError(error => {
                    const alertPayload = {
                        message: '',
                        variant: "danger"
                    };

                    let submitErrors:any = {}

                    if(error.status) {
                        switch(error.status) {
                            case 409:
                                alertPayload.message = this.$t('container.alerts.errors.identificationNumberAlreadyAttributed') as string
                                submitErrors.identifier = this.$t('container.validationErrors.identificationNumberAlreadyAttributed') as string
                                break
                        }
                    }

                    this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                    return of({
                        success: false, 
                        data: submitErrors,
                    })
                }),
            )

            return new Promise((resolve, reject) => { // returning promise: see onSubmit specs final form
                createContainer$.subscribe((res) => {
                    if(res.success) {
                        this.$router.push({
                            name: Routes.CONTAINER,
                            params: { id: res.data as string },
                        })
                        // @ts-ignore
                        resolve()
                    } else {
                        resolve(res.data)
                    }
                })
            })
    }
}
